export default function () {
	function createCircularText(element) {
		const text = element.getAttribute('data-text')
		if (!text) return

		const chars = text.split('')
		const angleStep = 360 / chars.length

		chars.forEach((char, index) => {
			if (char !== ' ') {
				const span = document.createElement('span')
				const textElement = document.createElement('div')

				textElement.className = 'circle-text'
				textElement.style.transform = `rotate(${index * angleStep}deg)`

				span.textContent = char
				textElement.appendChild(span)
				element.appendChild(textElement)
			}
		})
	}

	function handlePlayButtons() {
		const playButtons = document.querySelectorAll('[data-play-video]')

		playButtons.forEach(button => {
			button.addEventListener('click', function() {
				const videoSelector = this.getAttribute('data-play-video')
				const video = document.querySelector(videoSelector)

				if (!video) return

				if (video.paused) {
					video.play().then(() => {
						this.style.opacity = '0'
						this.style.pointerEvents = 'none'
					}).catch(error => {
						console.error('Video play error:', error)
					})
				} else {
					// Wstrzymaj wideo
					video.pause()
					// Pokaż przycisk play
					this.style.opacity = '1'
					this.style.pointerEvents = 'auto'
				}
			})
		})

		const videos = document.querySelectorAll('video')
		videos.forEach(video => {
			video.addEventListener('click', function() {
				const playButton = this.parentElement.querySelector('.btn-play-video')

				if (this.paused) {
					this.play().then(() => {
						if (playButton) {
							playButton.style.opacity = '0'
							playButton.style.pointerEvents = 'none'
						}
					}).catch(error => {
						console.error('Video play error:', error)
					})
				} else {
					this.pause()
					if (playButton) {
						playButton.style.opacity = '1'
						playButton.style.pointerEvents = 'auto'
					}
				}
			})

			video.addEventListener('ended', function() {
				const playButton = this.parentElement.querySelector('.btn-play-video')
				if (playButton) {
					playButton.style.opacity = '1'
					playButton.style.pointerEvents = 'auto'
				}
			})

			video.parentElement.addEventListener('mouseenter', function() {
				const playButton = this.querySelector('.btn-play-video')
				const video = this.querySelector('video')

				if (playButton && video && video.paused) {
					playButton.style.opacity = '1'
				}
			})

			video.parentElement.addEventListener('mouseleave', function() {
				const playButton = this.querySelector('.btn-play-video')
				const video = this.querySelector('video')

				if (playButton && video && !video.paused) {
					playButton.style.opacity = '0'
				}
			})
		})
	}

	document.addEventListener('DOMContentLoaded', () => {

		const circleElements = document.querySelectorAll('[data-css-circle]')
		if (circleElements.length > 0) {
			circleElements.forEach((element) => {
				createCircularText(element)
			})
		}

		handlePlayButtons()
	})
}